import { useEffect, useRef, useState } from 'react'

import '../../../styles/reports/reports-common.scss';
import { focusElement, handlekeyDown } from '../../../components/generics/helper';
import BrandAutocomplete from '../../../components/formik-form-components/BrandAutocomplete';
import CategoryAutocomplete from '../../../components/formik-form-components/CategoryAutocomplete';
import ItemAutocomplete from '../../../components/formik-form-components/ItemAutocomplete';
import SerialNoFromInventoryAutocomplete from '../../../components/formik-form-components/SerialNoFromInventoryAutocomplete';
import TyreReportList from './TyreReportList';
import VehicleAutocomplete from "../../../components/formik-form-components/VehicleAutocomplete";
import TyrePositionAutocomplete from '../../../components/formik-form-components/TyrePositionAutocomplete';

const TyreReport = () => {
    const filterInitialValue = { searchCategoryIds: '', searchCategoryNames: [], searchSuperCategory: '', searchSubCategoryIds: '', searchSubCategoryNames: [], searchBrandIds: '', searchBrandNames: [], searchItemIds: '', searchItemNames: [], searchVehIds: '', searchVehNos: [], searchTyrePositionValues: '',searchTyrePositionLabels:[], searchSerialNos: '', showTable: false, };
    const [tyreReportFilters, setTyreReportFilters] = useState(filterInitialValue);
    const [loadData, setLoadData] = useState(false);

    const vehicleNoFilterRef = useRef(null);
    const tyrePositionFilterRef = useRef(null);
    const categoryFilterRef = useRef(null);
    const subCategoryFilterRef = useRef(null);
    const brandFilterRef = useRef(null);
    const itemFilterRef = useRef(null);
    const srNoFilterRef = useRef(null);

    const tyreReportFilterReset = () => {
        setTyreReportFilters({ ...filterInitialValue });
        vehicleNoFilterRef.current.resetAutocomplete();
        tyrePositionFilterRef.current.resetAutocomplete();
        categoryFilterRef.current.resetAutocomplete();
        subCategoryFilterRef.current.resetAutocomplete();
        brandFilterRef.current.resetAutocomplete();
        itemFilterRef.current.resetAutocomplete();
        srNoFilterRef.current.resetAutocomplete();
    }

    const generateTyreReport = () => {
        setTyreReportFilters((prev) => ({ ...prev, showTable: true }))
        setLoadData(true);
    }

    useEffect(() => {
        focusElement('searchVehNoIds')
    }, [])

    return (
        <>
            <div key="tr_wrapper" className="report--wrapper">
                <div key="tr_filter_wrapper" className="report--filter--wrapper tyre--report--filter">
                    <div className="input--container">
                        <VehicleAutocomplete
                            name="searchVehNoIds"
                            id="searchVehNoIds" nextId="searchTyrePositionIds" prevId=""
                            isCompulsory={false}
                            singleSelect={false}
                            label={"Vehicle Number"}
                            searchPlaceholder={"Search By Vehicle Number"}
                            noDataLabel={"No Vehicle Found"}
                            listWidth={320}
                            onlyLoginBranchAppVehicles='Y'
                            selectedValues={tyreReportFilters?.searchVehIds ? tyreReportFilters.searchVehIds.split(',') : []}
                            onSelect={(selectedVehicles, currentSelection) => {
                                const searchVehIds = selectedVehicles.map((v) => v.vehicleId).sort().join(',');
                                const searchVehNos = selectedVehicles.map((v) => v.vehicleNo).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchVehIds, searchVehNos, showTable: false }));
                            }}
                            onRemove={(selectedVehicles, currentSelection) => {
                                const searchVehIds = selectedVehicles.map((v) => v.vehicleId).sort().join(',');
                                const searchVehNos = selectedVehicles.map((v) => v.vehicleNo).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchVehIds, searchVehNos, showTable: false }));
                            }}
                            ref={vehicleNoFilterRef}
                        />
                    </div>
                    <div className="input--container">
                        <TyrePositionAutocomplete
                            name="searchTyrePositionIds"
                            id="searchTyrePositionIds" nextId="searchCategoryIds" prevId="searchVehNoIds"
                            isCompulsory={false}
                            singleSelect={false}
                            label={"Tyre Position"}
                            searchPlaceholder={"Search By Tyre Position"}
                            noDataLabel={"No Tyre Position Found"}                                                   
                            selectedValues={tyreReportFilters?.searchTyrePositionValues ? tyreReportFilters.searchTyrePositionValues.split(',') : []}
                            onSelect={(selectedPositions, currentSelection) => {
                                const searchTyrePositionValues = selectedPositions.map((v) => v.value).sort().join(',');
                                const searchTyrePositionLabels = selectedPositions.map((v) => v.label).sort();                                
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchTyrePositionValues,searchTyrePositionLabels, showTable: false }));
                            }}
                            onRemove={(selectedPositions, currentSelection) => {
                                const searchTyrePositionValues = selectedPositions.map((v) => v.value).sort().join(',');
                                const searchTyrePositionLabels = selectedPositions.map((v) => v.label).sort();                                
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchTyrePositionValues,searchTyrePositionLabels, showTable: false }));
                            }}
                            ref={tyrePositionFilterRef}
                        />
                    </div>
                    <div key="tr_filter_inp_category" className="input--container">
                        <CategoryAutocomplete
                            id="searchCategoryIds" nextId="searchSubCategoryIds" prevId="searchTyrePositionIds"
                            name="searchCategoryIds"
                            label="Category"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            searchPlaceholder="Search By Category"
                            noDataLabel="No Category Found"
                            categoryFor={1}
                            isParent="Y"
                            selectedValues={tyreReportFilters?.searchCategoryIds ? tyreReportFilters.searchCategoryIds.split(',') : []}
                            onSelect={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            ref={categoryFilterRef}
                        />
                    </div>
                    <div key="tr_filter_inp_subCategory" className="input--container">
                        <CategoryAutocomplete
                            id="searchSubCategoryIds" nextId="searchBrandIds" prevId="searchCategoryIds"
                            name="searchSubCategoryIds"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            label="Sub Category"
                            searchPlaceholder="Search By Sub Category"
                            noDataLabel="No Sub Category Found"
                            categoryFor={1}
                            isParent="N"
                            parentCategoryId={tyreReportFilters.searchCategoryIds}
                            selectedValues={tyreReportFilters?.searchSubCategoryIds ? tyreReportFilters.searchSubCategoryIds.split(',') : []}
                            onSelect={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            ref={subCategoryFilterRef}
                        />
                    </div>
                    <div key="tr_filter_inp_brand" className="input--container" >
                        <BrandAutocomplete
                            id={'searchBrandIds'} nextId="searchItemIds" prevId="searchSubCategoryIds"
                            name="searchBrandIds"
                            label="Brand"
                            searchPlaceholder="Search By Brand Category"
                            noDataLabel="No Brand Found"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            brandsFor={tyreReportFilters?.searchSuperCategory?.toString()}
                            selectedValues={tyreReportFilters?.searchBrandIds ? tyreReportFilters.searchBrandIds.split(',') : []}
                            onSelect={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            onRemove={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            ref={brandFilterRef}
                        />
                    </div>
                    <div key="tr_filter_inp_item" className="input--container" >
                        <ItemAutocomplete
                            id="searchItemIds" nextId="searchSrNoIds" prevId="searchBrandIds"
                            name="searchItemIds"
                            label={"Item Name"}
                            searchPlaceholder={"Search By Item Name"}
                            noDataLabel={"No Item Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={440}
                            forAllItems={'Y'}
                            forCategory={tyreReportFilters?.searchCategoryIds}
                            forSubCategory={tyreReportFilters?.searchSubCategoryIds}
                            forBrand={tyreReportFilters?.searchBrandIds}
                            onlySerialNoApplicable='Y'
                            onlyLoginBranchMappedModelsItems={true}
                            selectedValues={tyreReportFilters?.searchItemIds ? tyreReportFilters.searchItemIds.split(',') : []}
                            onSelect={(selectedItems, currentSelection) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            onRemove={(selectedItems, currentSelection) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setTyreReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            ref={itemFilterRef}
                        />
                    </div>
                    <div key="tr_filter_inp_serialNo" className="input--container" >
                        <SerialNoFromInventoryAutocomplete
                            id='searchSrNoIds' nextId="generate" prevId="searchItemIds"
                            name='searchSrNoIds'
                            label='Serial No'
                            searchPlaceholder={"Search By Serial No"}
                            noDataLabel={"No Serial No Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={240}
                            itemId={tyreReportFilters.searchItemIds}
                            selectedValues={tyreReportFilters?.searchSerialNos ? tyreReportFilters.searchSerialNos.split(',') : []}
                            onSelect={(selectedSerialNos, currentSelection) => {
                                const searchSerialNos = selectedSerialNos.map((v) => v.serialNo).sort().join(',');
                                setTyreReportFilters(prev => ({ ...prev, searchSerialNos, showTable: false }));
                            }}
                            onRemove={(selectedSerialNos, currentSelection) => {
                                const searchSerialNos = selectedSerialNos.map((v) => v.serialNo).sort().join(',');
                                setTyreReportFilters(prev => ({ ...prev, searchSerialNos, showTable: false }));
                            }}
                            ref={srNoFilterRef}
                        />
                    </div>
                    <div className='btn--container'>
                        <div className="dashed--btn" id="generate" tabIndex="0" style={{ marginLeft: '0' }} onClick={() => { generateTyreReport(); }}
                            onKeyDown={(e) => { handlekeyDown(e, `searchVehNoIds`, `resetBtn`, `generate`) }}>Generate Report</div>
                        <div key="tr_filter_inp_frd" className="dashed--btn" onClick={() => tyreReportFilterReset()}
                            id="resetBtn"
                            tabIndex="0"
                            onKeyDown={(e) => { handlekeyDown(e, `generate`, `searchVehNoIds`, `resetBtn`) }}>Reset
                        </div>
                    </div>
                </div>
                <div key="tr_container" className="report--container">
                    {tyreReportFilters?.showTable && <TyreReportList tyreReportFilters={tyreReportFilters} loadData={loadData} setLoadData={setLoadData} />}
                </div>
            </div>
        </>
    )
}
export default TyreReport;